<template>
  <div class="zhenhe">
    <lff ref="lff" @spon="transfer"></lff>
    <lzg ref="lzg" @spon="transfer"></lzg>
    <myFooter theme="dark"></myFooter>
  </div>
</template>
<script>
import lff from './lff.vue'
import lzg from './lzg.vue'
import myFooter from '@/components/footer.vue'
export default {
  metaInfo() {
    return {
      title: `考研辅导班_研究生备考辅导培训_中课网校`,
      meta: [
        {
          name: 'keywords',
          content: '在职考研,考研辅导,考研培训,考研专业课,在校考研'
        },
        {
          name: 'description',
          content:
            '中课网校是专注学历提升，职业资格证书等在线报考，培训的学习平台，为广大学子提供考研公共课，专业课等全科辅导，有畅学班，全程班等授课，专注考研辅导，考研培训等多样课程满足各位学生的个性化需求。'
        }
      ]
    }
  },
  components: {
    lff,
    lzg,
    myFooter
  },
  methods: {
    transfer(obj) {
      this.$refs[obj.ref][obj.fn]()
    }
  }
}
</script>
